var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VContentCard',[_c('template',{slot:"advertise"},[_c('VAdvertiseImage',{attrs:{"visible":_vm.advertise.visible,"image":_vm.advertise.image,"link":_vm.advertise.link}})],1),_c('template',{slot:"form"},[_c('ForgotPasswordScreenForm')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }